import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import {
  Box,
  Divider,
  IconButton,
  SxProps,
  TextField,
  Tooltip,
} from '@mui/material'
import Container from '@mui/material/Container'
import { CSSProperties, useState } from 'react'
import { useForm } from 'react-hook-form'

import KanseiBreadcrumbs from 'components/breadcrumb'
import KanseiButton from 'components/button'
import KanseiTextField from 'components/textField'
import { toolApi } from 'hooks/api/tool'

type Form = {
  count: string
}

const GenULID = () => {
  const [result, setResult] = useState<string[]>([])
  const [copied, setCopied] = useState(false)

  const { control, handleSubmit } = useForm<Form>({
    defaultValues: { count: '' },
  })

  const onSubmit = async (form: Form) => {
    const count = parseInt(form.count)
    if (isNaN(count) || count <= 0) {
      alert('1以上の整数を入力してください')
      return
    }
    const ulids = await toolApi().genUlid(count)
    setResult(ulids.data)
    setCopied(false)
  }

  const handleCopy = () => {
    if (result.length === 0) return
    navigator.clipboard.writeText(result.join('\n'))
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={formStyle}>
      <Box sx={inputRowStyle}>
        <KanseiTextField
          id="count"
          control={control}
          label="生成数"
          placeholder="10"
          type="number"
          fullWidth={false}
          style={countInputStyle}
        />
        <KanseiButton buttonType="submit">生成</KanseiButton>
      </Box>

      <Box sx={resultContainerStyle}>
        <TextField
          multiline
          rows={10}
          fullWidth
          value={result.join('\n')}
          placeholder="生成されたULIDがここに表示されます"
          InputProps={{
            readOnly: true,
          }}
          sx={resultTextFieldStyle}
        />
        {result.length > 0 && (
          <Tooltip
            title={copied ? 'コピーしました！' : 'クリップボードにコピー'}
          >
            <IconButton onClick={handleCopy} sx={copyButtonStyle}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  )
}

export default function ToolPage() {
  const links = [
    {
      title: '開発用ツール',
    },
  ]

  return (
    <Container>
      <KanseiBreadcrumbs links={links} style={breadcrumbStyle} />

      <Divider>ULID生成</Divider>
      <GenULID />
    </Container>
  )
}

// styles
const breadcrumbStyle: CSSProperties = {
  marginBottom: '15px',
}

const formStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  marginTop: 2,
}

const inputRowStyle: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
}

const countInputStyle: CSSProperties = {
  width: 120,
}

const resultContainerStyle: SxProps = {
  position: 'relative',
}

const resultTextFieldStyle: SxProps = {
  '& .MuiInputBase-input': {
    fontFamily: 'monospace',
    fontSize: 14,
  },
}

const copyButtonStyle: SxProps = {
  position: 'absolute',
  top: 8,
  right: 8,
}
